module.exports = __webpack_public_path__ + "static/Print pattern XS-02_colorbase_3000-01-72c8c44d2964f32fe7a468777159ef4a.png";